import { api,catchHandler } from "./axios";
import config from "../config"
import moment  from "moment";

export function track(payload){
    return api()
    .post(config.routes.segment, payload)
    .then(res => res.data)
    .catch(catchHandler) 
}
export function unAuthtrack(payload){
  return api()
  .post(`${config.routes.segment}/un-auth`, payload)
  .then(res => res.data)
  .catch(catchHandler) 
}

export function trackLinkClicks(payload){
  return api()
  .post(`${config.routes.segment}/un-auth`, payload)
  .then(res => res.data)
  .catch(catchHandler) 
}

export function frontendTrack(eventDetails) {
  if(eventDetails.event && eventDetails.properties){  
    let properties = {...eventDetails.properties}
    window.analytics.track(eventDetails.event,{
        ...properties
    });
  }
}

export function trackPaymentRequestComplete(trackingData) {
  const {amount, tip, total, payment_collection_method, payment_request_type, user_id, user_unique_id, end_user_id, enduser_payment_button_clicked, company_id, business_name, role, created_at, mcc_code, business_category, business_email_address, platform} = trackingData;

  const data = {
      "event": "payment_request_complete",
      "properties": {
          "payment_request_amount": amount, 
          "enduser_payment_button_clicked": enduser_payment_button_clicked,
          "tip_amount": tip,
          "payment_amount_total": total,
          "payment_collection_method": payment_collection_method,
          "payment_request_type": payment_request_type,
          "user_id": user_id, 
          "user_unique_id": user_unique_id, 
          "end_user_id": end_user_id,
          "company_id": company_id, 
          "business_name": business_name, 
          "role": role,
          "account_creation_date": created_at, 
          "mcc_code": mcc_code, 
          "business_category": business_category,
          "business_email_address": business_email_address, 
          "platform": platform
      }
  }

  frontendTrack(data);
}

export function trackEachPaymentOnMethodComplete(trackingData) {
  const {amount, tip, total, payment_collection_method, tip_button_clicked, payment_request_type, user_id, user_unique_id, end_user_phone, end_user_email_address, enduser_payment_button_clicked, company_id, business_name, role, created_at, mcc_code, business_category, business_email_address, due_date, platform, recurring_invoice_id , repeat_schedule ,start_date,end_date_selected, end_date, due_date_selected, send_to_contacthub} = trackingData;
  const getEvent = (payment_request_type) => {
    if (payment_request_type === "quick_pay") {
      return "quickpay_request_complete";
    }else if(payment_request_type === "invoice"  && recurring_invoice_id){
      return "invoice_recurring_request_complete";
    } else if (payment_request_type === "invoice") {
      return "invoice_request_complete";
    } else if (payment_request_type === "quickpay_booking") {
      return "booking_request_complete";
    } else {
      return "end_user_new_payment_request_complete";
    }
  }
  let recurringData = {}
  if(recurring_invoice_id){
    recurringData = {
      repeat_schedule,
      start_date,
      end_date_selected,
      end_date,
      due_date_selected,
      send_to_contacthub,
      date: moment().format('MM-DD-YYYY hh:mm:ss')
    }                 
  }
  const data = {
      "event": getEvent(payment_request_type),
      "properties": {
        "payment_request_type": payment_request_type,
        "payment_request_amount": amount, 
        "enduser_payment_button_clicked": enduser_payment_button_clicked,
        "tip_button_clicked": tip_button_clicked,
        "tip_amount": tip,
        "payment_amount_total": total,
        "payment_collection_method": payment_collection_method,
        "end_user_phone": end_user_phone,
        "end_user_email_address": end_user_email_address,
        "user_id": user_id, 
        "user_unique_id": user_unique_id, 
        "company_id": company_id, 
        "business_name": business_name, 
        "role": role,
        "account_creation_date": created_at, 
        "mcc_code": mcc_code, 
        "business_category": business_category,
        "business_email_address": business_email_address, 
        "platform": platform,
        ...recurringData
      }
  }

  if (due_date) data["properties"]["due_date"] = due_date;

  frontendTrack(data);
}